export const main = {
  Hero: {},

  Spacing: { boxSize: 'D1' },

  ProductRow: {},

  Footer: {}
}
